The proposed state of the job ad to be posted or updated.
